import { GridColDef } from "@mui/x-data-grid-pro";
import { DefaultMoneyInput } from "../../../../../../common/components/default_money_input";


type Props = {
    OnActionValorChange(valorRateio: string | null, idRateioGeral: number): void,

};


export const GenerateRateioGeralColumns = ({
    OnActionValorChange,

}: Props):
    GridColDef[] => {

    return [
        {
            field: "nomeCentroCusto",
            filterable: false,
            headerName: "Centro Custo",
            flex: 1,
            minWidth: 200,
            sortable: false,
        },
        {
            field: "valorRateio",
            filterable: false,
            width: 150,
            maxWidth: 200,
            headerAlign: "center",
            headerName: "Valor Rateio",
            sortable: false,
            renderCell: (params) => {
                const { row } = params;

                const value: number | undefined = row.valorRateio !== null && row.valorRateio !== undefined
                    ? row.valorRateio
                    : undefined;

                return (
                    <DefaultMoneyInput
                        name={`valorRateio-${row.idRateioGeral}`}
                        label=""
                        readOnly={false}
                        value={value ?? null}
                        onChangeValue={(novoValor) => {
                            const valorString = novoValor !== null ? novoValor.toString() : null;
                            OnActionValorChange(valorString, row.idRateioGeral);
                        }}
                    />
                );
            },
        }
    ];
}

